module.exports = "https://p.cds.unp.clasificados.pe/bg-educacion.bac116b743e28ca58814c538af23730a.jpg";